export default "__VITE_ASSET__5Ar_wR4k__"